var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "main-footer" }, [
    _c(
      "div",
      { staticClass: "strata-footer" },
      [
        _c(
          "b-link",
          {
            staticClass: "logo-link",
            attrs: { href: "http://strataplatforms.com" }
          },
          [
            _vm.isDesktop
              ? _c("img", {
                  staticClass: "logo-lg",
                  attrs: {
                    src: require("assets/images/StrataLogo_White_Horiz.png"),
                    alt: "Strata Platforms Logo"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isDesktop
              ? _c("img", {
                  staticClass: "logo-md",
                  attrs: {
                    src: require("assets/images/StrataLogo_White_Vert.png"),
                    alt: "Strata Platforms Logo"
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer-details" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "nav",
            { staticClass: "info" },
            [
              _c(
                "b-link",
                { staticClass: "info-link", attrs: { to: "/support" } },
                [_vm._v("\n          Support\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-link",
                { staticClass: "info-link", attrs: { to: "/privacy" } },
                [_vm._v("\n          Privacy Policy\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-link",
                { staticClass: "info-link", attrs: { to: "/terms" } },
                [_vm._v("\n          Terms of Use\n        ")]
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "rights-reserved" }, [
      _c("span", [_vm._v("Operating globally from Greenville, SC, USA")]),
      _vm._v(" "),
      _c("span", { staticClass: "divider" }, [_vm._v("|")]),
      _vm._v(" "),
      _c("span", [_vm._v("@2025 Strata Platforms. All Rights Reserved.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }